import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment'

import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import ListItemIcon from '@material-ui/core/ListItemIcon';

import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";



import AccessTimeIcon from '@material-ui/icons/AccessTime';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import CartIcon from 'mdi-material-ui/Cart';

import TagIcon from 'mdi-material-ui/Tag';

import PieGraph from './PieGraph'


import ComposedChart from 'recharts/es6/chart/ComposedChart'
import CartesianGrid from 'recharts/es6/cartesian/CartesianGrid'
import Area from 'recharts/es6/cartesian/Area'
import XAxis from 'recharts/es6/cartesian/XAxis'
import YAxis from 'recharts/es6/cartesian/YAxis'
import Tooltip from 'recharts/es6/component/Tooltip'



import ResponsiveContainer from 'recharts/es6/component/ResponsiveContainer'

const styles = theme => ({
  root:{
    display:"flex",
    justifyContent: "center",

    minHeight:"100vh",
    overflow:"auto",
  },

  dialog:{


  },


  dialogContent:{

    background: theme.palette.background.dark,
    padding:theme.spacing.unit * 5,
    paddingTop: 50,
  },

  pieGraphContainer:{
    height: "50vh",
    marginTop: theme.spacing.unit * 5,
  },

  graphContainer:{

    position: "absolute",
    left: 0,
    bottom: 0,
    width: "100%",

    height: "35vh",

    overflow: "hidden"
  },

  title:{
    fontSize: 40,
    color: theme.palette.common.white,
    textAlign: "center",
    textTransform: "uppercase"
  },


  list:{
    paddingTop:theme.spacing.unit * 2,
  },
  listItem:{
    fontSize: "1.1em",
    color: theme.palette.common.white,
    paddingTop:theme.spacing.unit * 1,

    textTransform: "uppercase"
  },
  listItemIcon:{
    fontSize: "3em",
    color:  theme.palette.primary.gold,
  },
  listItemHelper:{
    fontSize: "0.9em",
    textTransform: "initial"
  },

  statisticContainer:{
    position: "relative",
    paddingTop: theme.spacing.unit * 2,


    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent:"space-around",
    alignContent: "center"
  },

  statisticData:{
    padding: theme.spacing.unit * 1,


    textAlign:"center"
  },

  dialogMedia:{
    paddingTop: 30,
    position: "relative",
  },

  /// ORDER BUTTON
  orderButton:{
    color: theme.palette.common.white,
    borderColor: theme.palette.common.white,


    fontSize: 30
  },

  /// CLOSE BUTTON
  close:{
    position: "absolute",

    right: 20,
    top: 50
  },
  closeIcon:{
    fontSize: 40,
  },
});


class CustomizedLabel extends Component{
  render () {
    const {x, y, stroke, value, theme} = this.props;

   	return <text x={x} y={y} dy={-4} fill={stroke} fontSize={10} textAnchor="middle">{value}</text>
  }
}

class CustomizedAxisTick extends Component{
  render () {
    const {x, y, stroke, payload, theme} = this.props;

   	return (
    	<g transform={`translate(${x},${y})`}>
        <text x={0} y={0} dy={16} textAnchor="middle" fill="#666"  style={{fontFamily:"Kanit"}}>

          {
            moment.unix(payload.value).format("MM-YYYY")
          }
        </text>
      </g>
    );
  }
}

function Transition(props) {
  return <Slide direction="up" {...props} />;
}



class ProductDialog extends React.Component {
  state = {
    expanded: false,
    infoOpen: this.props.isActive,
    statistic: this.props.statistic ? this.props.statistic : {},
    budgetGraphData: this.props.graphData ? this.props.graphData : [],
    winLoseGraphData: this.props.statistic ? this.getWinLoseGraphData(this.props.statistic): []
  }

  static contextTypes = {
    router: PropTypes.object
  }

  componentDidUpdate(prevProps){

    if(prevProps.isActive !== this.props.isActive){

      this.setState({infoOpen: this.props.isActive})
    }
  }

  getWinLoseGraphData(statistic){
    return [
      {name:"Zmag",value:statistic.betsWon, fill:this.props.theme.palette.primary.gold},
      {name:"Porazov", value: statistic.betsPlayed-statistic.betsWon}
    ]
  }

  simpleLineChart = (data, dataKey) =>{

      if(data[0]){
        return (
          <ResponsiveContainer width={"100%"} height={"100%"}>
            <ComposedChart  data={data} >
             <XAxis domain={[data[0].month, data[data.length-1].month]} type="number"  dataKey="month" hide={false} axisLine={false} tick={<CustomizedAxisTick theme={this.props.theme}/>} />
             <YAxis domain={["auto","auto"]} mirror allowDataOverflow={true}  dataKey={dataKey} hide={true} axisLine={false} />
             <Tooltip cursor={false} content={this.renderAreaGraphTooltip} />
             <CartesianGrid vertical={false}/>
             <Area  dataKey={dataKey} connectNulls={true}  stroke={this.props.theme.palette.primary.dark} fillOpacity="0.6" fill={this.props.theme.palette.primary.gold} />
            </ComposedChart>
          </ResponsiveContainer>
        )
      }

  }

  renderAreaGraphTooltip = (props)=>{

    const {label, payload} = props

    if(payload){
      return(
        <div style={{padding: this.props.theme.spacing.unit * 2,  background:"white", boxShadow: this.props.theme.shadows[5], borderRadius: 10, }}>

          <Typography style={{padding: this.props.theme.spacing.unit, textTransform: "uppercase" }} variant="title">{moment.unix(label).format("MM-YYYY")}</Typography>
          <Divider />
          <div style={{display: "flex", flexDirection:"row", flexWrap: "wrap"}}>
            {payload.map((obj, i) =>{
              return(
                <div key={i} style={{padding: this.props.theme.spacing.unit, flexGrow: 6, textAlign: "center"}}>
                  <Typography variant="title" style={{ textTransform: "uppercase"}} >{obj.name}</Typography>
                  <Typography variant="body1">{obj.value} enot</Typography>
                </div>
              )
            })}
          </div>
        </div>
      )
    }
  }



  openDialog = ()=>{
    this.setState({infoOpen: true})
  }

  closeDialog = ()=>{
    this.props.callback("CLOSE")

  }

  handleExpandClick = () => {
    this.setState(state => ({ expanded: !state.expanded }));
  }

  goToPayment = ()=>{
    this.context.router.history.push(`/narocilo/${this.props.product.id}`)
  }

  render() {
    const { classes, product } = this.props;
    const { statistic } = this.state

    return (

        <Dialog
          fullScreen
          open={this.state.infoOpen}
          onClose={this.closeDialog}
          TransitionComponent={Transition}
        >
          <div className={classes.root} >

            <Grid container className={classes.dialog} justify="center">
              <Grid item sm={12} md={12} lg={5}  className={classes.dialogContent}>

                <Typography variant="title" className={classes.title}>
                  {product.name}
                </Typography>

                <div className={classes.list}>
                  <List >
                    <div style={{display:"flex", flexDirection: "row"}}>

                        {
                          product.settings.subscriptionUnits  ? (
                            <ListItem >
                              <ListItemIcon className={classes.listItemIcon}>
                                <CartIcon />
                              </ListItemIcon>
                              <Typography variant="body1" className={classes.listItem}>
                                    <span>{product.settings.subscriptionUnitsAmount} ENOT</span>
                              </Typography>
                            </ListItem>
                          ):(
                            <ListItem >
                              <ListItemIcon className={classes.listItemIcon}>
                                <AccessTimeIcon />
                              </ListItemIcon>
                              <Typography variant="body1" className={classes.listItem}>
                                {
                                  product.settings.subscriptionSpan === 1 && (
                                    <span>{product.settings.subscriptionSpan} mesec</span>
                                  )
                                }
                                {
                                  product.settings.subscriptionSpan === 2 && (
                                    <span>{product.settings.subscriptionSpan} meseca</span>
                                  )
                                }
                                {
                                  product.settings.subscriptionSpan >= 3 && (
                                    <span>{product.settings.subscriptionSpan} mesecev</span>
                                  )
                                }
                              </Typography>
                            </ListItem>

                        )
                      }


                      <ListItem >
                        <ListItemIcon className={classes.listItemIcon}>
                          <TagIcon />
                        </ListItemIcon>
                        <Typography variant="body1" className={classes.listItem}>
                          {product.amount} €
                        </Typography>
                      </ListItem>
                    </div>
                    {
                     product.informations &&  Object.keys(product.informations).map((key)=>{

                        return(
                          <ListItem key={key}>
                            <ListItemIcon className={classes.listItemIcon}>
                              <ArrowRightIcon />
                            </ListItemIcon>
                            <Typography variant="body1" className={classes.listItem}>
                              {product.informations[key].text}
                              <br/>
                              <span className={classes.listItemHelper}>{product.informations[key].textSmall}</span>
                            </Typography>
                          </ListItem>
                        )
                      })
                    }
                  </List>
                  <div style={{display:"flex", flexDirection:"row", justifyContent: "space-around", marginTop:"24"}}>
                    <Button onClick={this.goToPayment} variant="outlined"  className={classes.orderButton} fullWidth>
                      NAROČI
                    </Button>
                    <Button onClick={this.closeDialog}  className={classes.orderButton} fullWidth>
                      Nazaj
                    </Button>
                  </div>

                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={7} className={classes.dialogMedia}>
                <Grid container>
                  <Grid item xs={12} sm={12} className={classes.statisticContainer}>

                    <div className={classes.statisticData}>
                      <Typography variant="headline" style={{textTransform: "uppercase", fontSize: 25}}>
                        {statistic.betsPlayed}
                      </Typography>
                      <Divider />
                      <Typography variant="subheading" style={{textTransform: "uppercase", fontSize:15, }}>
                        Vseh stav
                      </Typography>

                    </div>
                    <div className={classes.statisticData}>
                      <Typography variant="headline" style={{textTransform: "uppercase", fontSize: 25}}>
                        {statistic.betsWonAvrage} %
                      </Typography>
                      <Divider />
                      <Typography variant="subheading" style={{textTransform: "uppercase", fontSize:15, }}>
                        Vseh zmag
                      </Typography>

                    </div>
                    <div className={classes.statisticData}>
                      <Typography variant="headline" style={{textTransform: "uppercase", fontSize: 25}}>
                        {statistic.inputs} enot
                      </Typography>
                      <Divider />
                      <Typography variant="subheading" style={{textTransform: "uppercase", fontSize:15, }}>
                        Vložki
                      </Typography>

                    </div>

                    <div className={classes.statisticData}>
                      <Typography variant="headline" style={{textTransform: "uppercase", fontSize: 25}}>
                        {(statistic.odds/statistic.betsPlayed).toFixed(2)}
                      </Typography>
                      <Divider />
                      <Typography variant="subheading" style={{textTransform: "uppercase", fontSize:15, }}>
                        povpr. kvota
                      </Typography>

                    </div>
                    <div className={classes.statisticData}>
                      <Typography variant="headline" style={{textTransform: "uppercase", fontSize: 25}}>
                        {statistic.profit}e
                      </Typography>
                      <Divider />
                      <Typography variant="subheading" style={{textTransform: "uppercase", fontSize:15, }}>
                        PROFIT
                      </Typography>

                    </div>
                  </Grid>
                  <Hidden mdDown>
                    <Grid item xs={12} sm={6} >
                      <div  className={classes.pieGraphContainer}>
                        <PieGraph
                          theme={this.props.theme}
                          data={[{name:"Zmage", value:statistic.betsWon}, {name:"Porazi", value:statistic.betsPlayed-statistic.betsWon}]}
                          dataType={"number"}
                          centerText={
                            Math.ceil(100*(statistic.betsWon)/statistic.betsPlayed)+"%"
                          }
                          title={""}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <div  className={classes.pieGraphContainer}>
                        <PieGraph
                          theme={this.props.theme}
                          data={[{name:"Vložek", value:statistic.inputs}, {name:"Vračilo", value:statistic.returns}]}
                          dataType={"number"}
                          centerText={
                            Math.ceil(100*(statistic.returns-statistic.inputs)/statistic.inputs)+"%"
                          }
                          title={"ROI"}
                        />
                      </div>
                    </Grid>
                    <div className={classes.graphContainer}>
                        {this.simpleLineChart(this.state.budgetGraphData, "profit")}
                    </div>
                  </Hidden>



                </Grid>
              </Grid>

            </Grid>
          </div>

        </Dialog>


    );
  }
}

ProductDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  isActive: PropTypes.bool.isRequired,
  callback: PropTypes.func.isRequired,
  product: PropTypes.object.isRequired,
}

export default withStyles(styles, { withTheme: true })(ProductDialog);



// WEBPACK FOOTER //
// ./src/components/reusableComponents/ProductDialog.js